import { lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { resolvePatternCategory } from "../config/pattern-helpers";

const PatternDetailPage = lazy(() => import("../pages/PatternDetailPage"));
const PatternUsePage = lazy(() => import("../pages/PatternUsePage"));
const PatternsPage = lazy(() => import("../pages/PatternsPage"));

const LegacyCategoryRedirect = ({
  match,
}: {
  match: { params: { category?: string; patternId?: string } };
}) => {
  const resolved = resolvePatternCategory(match.params.category);
  if (!resolved) {
    return <Redirect to="/patterns" />;
  }
  const patternId = match.params.patternId;
  if (patternId) {
    return <Redirect to={`/patterns/${resolved}/${patternId}/copy-prompt`} />;
  }
  return <Redirect to={`/patterns/${resolved}`} />;
};

export function PatternsRoutes() {
  return (
    <Switch>
      <Route exact path="/patterns" component={PatternsPage} />
      <Route
        exact
        path="/patterns/:category/:patternId/copy-prompt"
        component={PatternUsePage}
      />
      <Route
        exact
        path="/patterns/:category/:patternId/use"
        render={({ match }) => (
          <Redirect
            to={`/patterns/${resolvePatternCategory(match.params.category) ?? "page"}/${match.params.patternId}/copy-prompt`}
          />
        )}
      />
      <Route
        exact
        path="/patterns/:category/:patternId"
        render={({ match }) => (
          <Redirect
            to={`/patterns/${resolvePatternCategory(match.params.category) ?? "page"}/${match.params.patternId}/copy-prompt`}
          />
        )}
      />
      <Route
        path={[
          "/patterns/brand",
          "/patterns/retailer",
          "/patterns/creative",
          "/patterns/components",
          "/patterns/brand/:patternId",
          "/patterns/retailer/:patternId",
          "/patterns/creative/:patternId",
          "/patterns/components/:patternId",
          "/patterns/brand/:patternId/copy-prompt",
          "/patterns/retailer/:patternId/copy-prompt",
          "/patterns/creative/:patternId/copy-prompt",
          "/patterns/components/:patternId/copy-prompt",
          "/patterns/brand/:patternId/use",
          "/patterns/retailer/:patternId/use",
          "/patterns/creative/:patternId/use",
          "/patterns/components/:patternId/use",
        ]}
        render={({ match }) => <LegacyCategoryRedirect match={match} />}
      />
      <Route path="/patterns/:category" component={PatternDetailPage} />
      <Route path="/templates" component={PatternsPage} />
    </Switch>
  );
}
